import createIcon from '../../createIcon';

/**
 * @component @name WbTwilight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMDc1OSA2LjUzOTgxTDE2Ljk1NTIgOC42NjIwMUwxOC4zNyAxMC4wNzU4TDIwLjQ5MDcgNy45NTM2MUwxOS4wNzU5IDYuNTM5ODFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjIgMThIMlYyMEgyMlYxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMyA0SDExVjdIMTNWNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik00Ljk1Njc0IDYuNTEwNjRMMy41NDI1NCA3LjkyNDg0TDUuNjYzODQgMTAuMDQ2MUw3LjA3ODA0IDguNjMxOTRMNC45NTY3NCA2LjUxMDY0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTUgMTZIMTlDMTkgMTIuMTMgMTUuODcgOSAxMiA5QzguMTMgOSA1IDEyLjEzIDUgMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WbTwilight = createIcon('WbTwilight', [
  [
    'path',
    {
      d: 'M19.0759 6.53981L16.9552 8.66201L18.37 10.0758L20.4907 7.95361L19.0759 6.53981Z',
      key: '1r1g4t',
    },
  ],
  ['path', { d: 'M22 18H2V20H22V18Z', key: 'kry7b7' }],
  ['path', { d: 'M13 4H11V7H13V4Z', key: '1eas9y' }],
  [
    'path',
    {
      d: 'M4.95674 6.51064L3.54254 7.92484L5.66384 10.0461L7.07804 8.63194L4.95674 6.51064Z',
      key: 'lx9ovn',
    },
  ],
  ['path', { d: 'M5 16H19C19 12.13 15.87 9 12 9C8.13 9 5 12.13 5 16Z', key: 'm6kan9' }],
]);

export default WbTwilight;
